import BuildingMultipleIndigoSvg from "@/src/assets/icons/icon-building-multiple-indigo.svg";
import ImportStatusIndigoSvg from "@/src/assets/icons/icon-calendar-today-indigo.svg";
import ImportStatusSvg from "@/src/assets/icons/icon-calendar-today.svg";
import ContractIndigoSvg from "@/src/assets/icons/icon-document-copy-indigo.svg";
import ContractSvg from "@/src/assets/icons/icon-document-copy-white.svg";
import FaqIndigoSvg from "@/src/assets/icons/icon-faq-indigo.svg";
import FaqSvg from "@/src/assets/icons/icon-faq.svg";
import FileBoxIndigoSvg from "@/src/assets/icons/icon-file-box-indigo.svg";
import FileBoxSvg from "@/src/assets/icons/icon-file-box-white.svg";
import HomeIndigoSvg from "@/src/assets/icons/icon-home-indigo.svg";
import HomeSvg from "@/src/assets/icons/icon-home.svg";
import InquiryIndigoSvg from "@/src/assets/icons/icon-inquiry-indigo.svg";
import InquirySvg from "@/src/assets/icons/icon-inquiry.svg";
import NoticeIndigoSvg from "@/src/assets/icons/icon-notice-indigo.svg";
import NoticeSvg from "@/src/assets/icons/icon-notice.svg";
import SettingSvg from "@/src/assets/icons/icon-setting.svg";
import IMPORTER_PRIVATE_PATH from "@/src/routes/importer/path";
import PUBLIC_PATH from "@/src/routes/public/path";

const IMPORTER_OPERATION_NAV_MENU = [
  {
    iconSrc: HomeIndigoSvg,
    selectedIconSrc: HomeSvg,
    labelKey: "sideNav:home",
    destination: IMPORTER_PRIVATE_PATH.HOME,
  },
  {
    iconSrc: ContractIndigoSvg,
    selectedIconSrc: ContractSvg,
    labelKey: "sideNav:importContract",
    destination: IMPORTER_PRIVATE_PATH.CONTRACT,
  },
  {
    iconSrc: ImportStatusIndigoSvg,
    selectedIconSrc: ImportStatusSvg,
    labelKey: "sideNav:importStatus",
    destination: IMPORTER_PRIVATE_PATH.SHIPMENT,
  },
  {
    iconSrc: ContractIndigoSvg,
    selectedIconSrc: ContractSvg,
    labelKey: "sideNav:sales",
    destination: IMPORTER_PRIVATE_PATH.SALES_MANAGEMENT,
  },
  {
    iconSrc: FileBoxIndigoSvg,
    selectedIconSrc: FileBoxSvg,
    labelKey: "sideNav:fileBox",
    destination: IMPORTER_PRIVATE_PATH.FILE_BOX,
  },
];

const IMPORTER_CUSTOMER_SERVICE_MENU = [
  {
    iconSrc: NoticeIndigoSvg,
    selectedIconSrc: NoticeSvg,
    labelKey: "sideNav:notice",
    destination: IMPORTER_PRIVATE_PATH.NOTICE,
  },
  {
    iconSrc: InquiryIndigoSvg,
    selectedIconSrc: InquirySvg,
    labelKey: "sideNav:inquiry",
    destination: IMPORTER_PRIVATE_PATH.INQUIRY,
  },
  {
    iconSrc: FaqIndigoSvg,
    selectedIconSrc: FaqSvg,
    labelKey: "sideNav:faq",
    destination: IMPORTER_PRIVATE_PATH.FAQ,
  },
];

const IMPORTER_MANAGEMENT_NAV_MENU = [
  {
    iconSrc: BuildingMultipleIndigoSvg,
    isOpen: false,
    labelKey: "sideNav:workspaceSettings",
    closeHeight: 72,
    fullHeight: 240,
    includePath: [
      "company-information",
      "member-management",
      "client-management",
    ],
    children: [
      {
        labelKey: "sideNav:companyInformation",
        destination: IMPORTER_PRIVATE_PATH.COMPANY_INFORMATION,
      },
      {
        labelKey: "sideNav:members",
        destination: IMPORTER_PRIVATE_PATH.MEMBER_MANAGEMENT,
      },
      {
        labelKey: "sideNav:clients",
        destination: IMPORTER_PRIVATE_PATH.CLIENT_MANAGEMENT,
      },
    ],
  },
  {
    iconSrc: SettingSvg,
    isOpen: false,
    labelKey: "sideNav:tradeSettings",
    closeHeight: 72,
    fullHeight: 120,
    includePath: ["item-management", "warehouse-management"],
    children: [
      {
        labelKey: "sideNav:items",
        destination: IMPORTER_PRIVATE_PATH.ITEM_MANAGEMENT,
      },
      {
        labelKey: "sideNav:warehouse",
        destination: IMPORTER_PRIVATE_PATH.WAREHOUSE_MANAGEMENT,
      },
    ],
  },
];

const IMPORTER_TERMS_POLICY_NAV_MENU = [
  {
    destination: `${PUBLIC_PATH.TERMS}?selectTab=termsOfUse`,
    isBlank: true,
    labelKey: "sideNav:termsOfUse",
  },
  {
    destination: `${PUBLIC_PATH.TERMS}?selectTab=privacyPolicy`,
    isBlank: true,
    labelKey: "sideNav:privacyPolicy",
  },
];

export {
  IMPORTER_OPERATION_NAV_MENU,
  IMPORTER_CUSTOMER_SERVICE_MENU,
  IMPORTER_MANAGEMENT_NAV_MENU,
  IMPORTER_TERMS_POLICY_NAV_MENU,
};
